import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import App from './components/App';

const rootEl = document.getElementById('hsReactRoot');

const root = ReactDOM.createRoot(rootEl);
// root.render(<StrictMode><App /></StrictMode>);
root.render(<App />);
